import { render, staticRenderFns } from "./releases_sort_apollo_client.vue?vue&type=template&id=30a5c338&"
import script from "./releases_sort_apollo_client.vue?vue&type=script&lang=js&"
export * from "./releases_sort_apollo_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports